export enum EFurnitureType {
  WithoutFurniture = 1,
  WithFurniture = 2,
}
